/** Enkel svensk pluralhjälp: plural(1, "visning", "visningar") → "1 visning". */
export function plural(n: number, one: string, many: string) {
  return `${n} ${n === 1 ? one : many}`;
}

/** Max antal tecken i en annonsrubrik – gäller både AI:n och manuell redigering. */
export const AD_TITLE_MAX = 70;
